var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 26.632 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.915,24V21.6H3.081V20.163H4.915V15.55A5.809,5.809,0,0,1,0,9.692a5.761,5.761,0,0,1,5.6-5.9,5.375,5.375,0,0,1,3.247,1.1,7.627,7.627,0,0,0,0,9.609A5.4,5.4,0,0,1,6.276,15.55v4.613H8.111V21.6H6.276V24ZM14,14.675a7.72,7.72,0,0,0,0-9.751,5.486,5.486,0,0,1,3.307-1.114,5.775,5.775,0,0,1,3.629,1.143l3.329-3.5H21.521V0h5.111V5.369H25.246V2.486l-3.328,3.5A6.505,6.505,0,0,1,23.009,9.8a5.858,5.858,0,0,1-5.7,5.99A5.486,5.486,0,0,1,14,14.675Zm-4-5.2c0-2.092.671-3.789,1.5-3.789S13,7.381,13,9.473s-.671,3.79-1.5,3.79S10,11.567,10,9.473Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGender);
export default __webpack_public_path__ + "static/media/icon-gender.e705df4402df5d8ed5114ee4448c2293.svg";
export { ForwardRef as ReactComponent };